import { EmailDisplay, OneLineEmailDisplay, SimpleEmailWidget } from "./simple.email.display";
import { DataPlugin, DisplayData, DisplayDataWidget } from "../../data";


export const EmailDataName = "email";
//{
//   "type": "email",
//   "hitId": "AAMkADE1NTIwNmJkLTc2MzUtNDgwOC1hNmE5LTYxZTVjNTY1YWE5YwBGAAAAAABNFAqxv1luRL7bEm5F1ZaxBwBhJiD8nMyASKmBiWNNB8P8AAAAAAEMAABhJiD8nMyASKmBiWNNB8P8AADcEIQMAAA=",
//   "rank": 1,
//   "summary": "...de. Manage all notifications · <c0>Hel</c0>p  ...",
//   "resource": {
//     "@odata.type": "#microsoft.graph.message",
//     "createdDateTime": "2025-03-30T10:07:43Z",
//     "lastModifiedDateTime": "2025-03-30T10:07:45Z",
//     "receivedDateTime": "2025-03-30T10:07:43Z",
//     "sentDateTime": "2025-03-30T10:07:40Z",
//     "hasAttachments": false,
//     "internetMessageId": "<307ac240.AVgAAGbl8m4AAAAAAAAAAQyOUo8AAP-LEp4AAAAAAATopABn6Rfs@mailjet.com>",
//     "subject": "me8eon-sap-connect-poc | Failed pipeline for refactor/search | 0c38651c",
//     "bodyPreview": "...de. Manage all notifications · Help  ...",
//     "importance": "normal",
//     "parentFolderId": "AAMkADE1NTIwNmJkLTc2MzUtNDgwOC1hNmE5LTYxZTVjNTY1YWE5YwAuAAAAAABNFAqxv1luRL7bEm5F1ZaxAQBhJiD8nMyASKmBiWNNB8P8AAAAAAEMAAA=",
//     "conversationId": "AAQkADE1NTIwNmJkLTc2MzUtNDgwOC1hNmE5LTYxZTVjNTY1YWE5YwAQAKNPM2C8F/FMlPPkoAOshTo=",
//     "isRead": false,
//     "isDraft": false,
//     "webLink": "https://outlook.office365.com/owa/?ItemID=AAMkADE1NTIwNmJkLTc2MzUtNDgwOC1hNmE5LTYxZTVjNTY1YWE5YwBGAAAAAABNFAqxv1luRL7bEm5F1ZaxBwBhJiD8nMyASKmBiWNNB8P8AAAAAAEMAABhJiD8nMyASKmBiWNNB8P8AADcEIQMAAA%3D&exvsurl=1&viewmodel=ReadMessageItem",
//     "inferenceClassification": "focused",
//     "replyTo": [
//       {
//         "emailAddress": {
//           "name": "Rice, Philip"
//         }
//       }
//     ],
//     "sender": {
//       "emailAddress": {
//         "name": "ESP GitLab",
//         "address": "ddp.bs.cps@eon.com"
//       }
//     },
//     "from": {
//       "emailAddress": {
//         "name": "ESP GitLab",
//         "address": "ddp.bs.cps@eon.com"
//       }
//     }
//   },
//   "source": "graphApiEmails"
// }
export type EmailData = {
    type: "email"
    source: string,
    hitId: string,
    rank: number,
    summary: string,
    resource: {
        "@odata.type": string,
        createdDateTime: string,
        lastModifiedDateTime: string,
        receivedDateTime: string,
        sentDateTime: string,
        hasAttachments: boolean,
        internetMessageId: string,
        subject: string,
        bodyPreview: string,
        importance: string,
        parentFolderId: string,
        conversationId: string,
        isRead: boolean,
        isDraft: boolean,
        webLink: string,
        inferenceClassification: string,
        replyTo: Array<{ emailAddress: { name: string } }>,
        sender: { emailAddress: { name: string, address: string } },
        from: { emailAddress: { name: string, address: string } }
    },
}

export function EmailDataPlugin(
    DisplayData: DisplayData<EmailData> = EmailDisplay,
    DisplayDataOneLine: DisplayData<EmailData> = OneLineEmailDisplay,
    DisplayDataWidget: DisplayDataWidget<EmailData> = SimpleEmailWidget): DataPlugin<EmailData> {
    return {
        plugin: "data",
        name: EmailDataName,
        DisplayData,
        DisplayDataOneLine,
        DisplayDataWidget,
        idFrom: data => `${data.type}.${data.hitId}`,
    };
}
